/** FAQ copy that already appears on each service page (for matching JSON-LD). */

export const DOG_GROOMING_FAQS = [
  {
    question: 'How frequently do dogs need grooming?',
    answer: "It varies depending on your dog's requirements. Dogs typically require grooming every 4-6 weeks; however, some may require more frequent sessions to be neat and cozy.",
  },
  {
    question: 'What does a complete grooming session contain?',
    answer: "A thorough grooming service includes everything, depending on the package you choose, whether it's a basic grooming or full grooming service ensuring full hygiene of your pet.",
  },
  {
    question: 'Will my dog become stressed because of grooming?',
    answer: "Your dog's comfort is our first priority so we use gentle, pet-friendly methods to provide a peaceful and enjoyable time. Our groomers have been qualified to pamper dogs of all breeds with love and care.",
  },
  {
    question: 'Do you use products suitable for sensitive skin?',
    answer: 'Absolutely! We utilize hypoallergenic products that are appropriate for all skin types. Please inform us beforehand if your dog has any known allergies.',
  },
  {
    question: 'How much time does a grooming session require for the dog?',
    answer: 'The length of time spent grooming a dog is governed by its demands, including size, coat condition, and services required. It typically takes between 1 and 3 hours.',
  },
  {
    question: 'Can I stay with my dog during the grooming session?',
    answer: 'Yes, you can stay throughout the initial consultation. Some dogs may be more relaxed if their owners are not there, but we will do whatever makes you and your dog the most comfortable.',
  },
];

export const CAT_GROOMING_FAQS = [
  {
    question: 'How regularly is it a good idea for me to brush my cat?',
    answer: 'Long-haired breeds require daily brushing, but short-haired variants may require weekly grooming sessions.',
  },
  {
    question: 'Does my cat need daily baths?',
    answer: 'No, daily bathing is not necessary. Daily bathing is only required for long-haired cats or those with skin problems. But it is recommended to give bath after 2 or 3 days, using mild and pet friendly products. You can consult us for any query relating to it.',
  },
  {
    question: 'How can I make their grooming more efficient if my cat has sensitive skin?',
    answer: 'If your pet has sensitive skin, hire a professional groomer or consult your veterinarian for recommendations. Additionally, use a fine bristle brush and brush gently to avoid causing a disruption.',
  },
  {
    question: "What can I do if my cat's fur is matted?",
    answer: 'If you see mats, carefully work them out with a comb. To avoid skin damage, mats may need to be carefully removed out by a professional groomer to avoid skin injury.',
  },
  {
    question: 'How should I respond if my cat dislikes grooming?',
    answer: 'If your cat is not ready to groom, begin gradually and utilize better feedback systems, such as recommendations or toys, to make the activity more pleasant. A professional groomer knows the tips and tricks to groom your cat so you can contact us.',
  },
  {
    question: 'Do I need to get my cat professionally groomed?',
    answer: 'Consider hiring a professional grooming service if your cat has significant cat problem or skin disorders that require specialized care, or if you need conducting particular grooming responsibilities you can hire us.',
  },
];

export const BIRD_GROOMING_FAQS = [
  {
    question: 'How frequently should you groom your bird?',
    answer: 'Wild birds require frequent grooming because of the outside exposure, while pet birds require grooming services roughly two to three times each year.',
  },
  {
    question: 'How much time is needed to groom a bird?',
    answer: 'The time required for bird grooming varies greatly depending on the service you choose and the breed of bird. Grooming a bird typically takes 30minutes to 1.5hour.',
  },
  {
    question: 'Do birds require brushing?',
    answer: 'Birds, like many other pets, need to groom themselves to look their best. Brushing will make them feel better while also removing some dust and molting feathers.',
  },
  {
    question: 'How can I safely trim my birds nails?',
    answer: 'To properly trim your bird nails, gently press on the paw to stretch the nail, then use bird nail clippers to cut just the tip. If your bird resists, trim only one or two nails at a time or get expert assistance.',
  },
  {
    question: 'What are the age limitations for bird grooming services?',
    answer: 'It is advised that your pet receive their first grooming when they are between 4 and 8 weeks old. We take excellent care of newbies.',
  },
  {
    question: "How can I know whether my bird's beak needs grooming?",
    answer: 'A healthy beak normally maintains itself by natural activity. If you see overgrowth, cracks, it might signal a health problem, and you should seek advice from a professional groomer on proper beak care.',
  },
];

export const RABBIT_GROOMING_FAQS = [
  {
    question: 'How frequently should I groom my rabbit?',
    answer: 'You should groom your rabbit at least once a week to maintain its coat healthy and free of mats and tangles. The frequency with which a rabbit must be groomed is determined by its breed; short-haired rabbits require grooming occasionally, but long-haired rabbits require grooming weekly.',
  },
  {
    question: 'How much time does a rabbit grooming session require?',
    answer: 'It depends significantly on the services you choose. However, we will groom your rabbit in 30 minutes to 2 hour.',
  },
  {
    question: 'Can I bathe my rabbit?',
    answer: 'Bathing is essential keep you rabbit’s hygiene, make sure the water is lukewarm and use a small quantity of rabbit-friendly shampoo.',
  },
  {
    question: 'What to do to clean Rabbit’s dirty coat?',
    answer: 'Work lightly with a brush or comb, starting at the borders and working inward. If the fur is in miserable condition, it is essential to hire a professional pet groomer.',
  },
  {
    question: 'How should I handle shedding and loose fur?',
    answer: 'Rabbits shed many times every year, particularly during seasonal changes. Brushing regularly during shedding seasons helps to remove loose fur and prevents hairballs from developing when rabbits groom themselves.',
  },
  {
    question: 'Are your grooming tools safe for rabbits?',
    answer: 'Yes, we utilize modern yet secure instruments for each session. Our pet groomers are trained to handle rabbits safely, reducing stress and preventing damage. You can rely on us for that.',
  },
];
